// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'e8bff6477b72f067dfc4565c47025ccadae2286d';
export const BUILD_NUMBER = '294';
export const BUILD_TIMESTAMP = '2026-11-03T23:27:31.419Z';
